export const useMaintenance = () => {
    const isMaintenance = useState('maintenance', () => false)

    const setMaintenance = (status: boolean) => {
        isMaintenance.value = status
    }

    return {
        isMaintenance,
        setMaintenance
    }
} 